<template>
    <div>
        <NavbarComponent />
        <div :class="{ 'pt-[75px] sm:pt-[85px]': !['calculator', 'account', 'home'].includes($route.name) }">
            <router-view />
        </div>
        <FooterComponent v-if="!isAccountRoute" />
    </div>
</template>
 
<script>
import NavbarComponent from "./components/NavbarComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
 
export default {
    name: "App",
    components: { NavbarComponent, FooterComponent },
    computed: {
        isAccountRoute() {
            return this.$route.name?.startsWith('account');
        }
    }
};
</script>